const prefix = 'heaven_knip_';

const keys = {
  ageVerified: `${prefix}ageVerified`,
};

const StorageUtil = {
  set: (key: string, val: string) => localStorage.setItem(key, val),
  get: (key: string) => localStorage.getItem(key) as string,
  clear: (key: string) => localStorage.removeItem(key),
};

export const storage = {
  ageVerified: {
    isVerified: () => StorageUtil.get(keys.ageVerified) === 'ok',
    setVerified: () => StorageUtil.set(keys.ageVerified, 'ok'),
    clear: () => StorageUtil.clear(keys.ageVerified),
  },
};
